import { plural } from '../types';

/** Catálogo base en español neutro (sin voseo ni marcas de género). `en` deriva su tipo de este. */
export const es = {
  common: {
    retry: 'Reintentar',
    appName: 'TELESCOPIO',
    points: '{score} pts',
    participants: plural({ one: '{count} participante', other: '{count} participantes' }),
  },
  nav: {
    mainNav: 'Navegación principal',
    home: 'Inicio',
    events: 'Eventos',
    howItWorks: 'Cómo funciona',
    login: 'Iniciar sesión',
    register: 'Crear cuenta',
    openMenu: 'Menú',
    languageMenu: 'Idioma: {code}',
    userMenu: 'Menú de usuario de {name}',
    myEvents: 'Mis eventos',
    notifications: 'Notificaciones',
    logout: 'Cerrar sesión',
  },
  notifications: {
    title: 'Notificaciones',
    bell: 'Notificaciones',
    bellWithCount: plural({ one: 'Notificaciones, {count} sin leer', other: 'Notificaciones, {count} sin leer' }),
    announce: plural({ one: '{count} notificación sin leer', other: '{count} notificaciones sin leer' }),
    newCount: plural({ one: '{count} nueva', other: '{count} nuevas' }),
    unreadEyebrow: '{count} SIN LEER',
    upToDateEyebrow: 'ESTÁS AL DÍA',
    intro: 'Todo lo que pasa en los eventos donde participas u organizas. Se guardan durante 90 días.',
    markAll: 'Marcar todo como leído',
    markAllError: 'No pudimos marcar las notificaciones. Prueba de nuevo.',
    viewAll: 'Ver todas las notificaciones',
    loadMore: 'Cargar más',
    loadingMore: 'Cargando…',
    loading: 'Cargando notificaciones…',
    loadingPanel: 'Cargando…',
    loadError: 'No pudimos cargar tus notificaciones.',
    empty: 'Estás al día. Te avisaremos aquí cuando pase algo en tus eventos.',
    unread: 'No leída',
    back: '← Volver',
    tags: {
      registration: 'Inscripción',
      voting: 'Votación',
      results: 'Resultados',
      myEvents: 'Mis eventos',
    },
    actions: {
      viewEvent: 'Ver evento',
      vote: 'Ir a votar',
      viewRanking: 'Ver ranking',
      viewRegistrations: 'Ver inscriptos',
      uploadFile: 'Subir archivo',
      viewMyRanking: 'Ver mi ranking',
    },
    types: {
      participationOpened: {
        title: '«{event}» abrió la inscripción',
        body: 'Ya puedes inscribirte y subir tu propuesta.',
      },
      votingAssigned: {
        title: 'Ya puedes votar en «{event}»',
        body: plural({
          one: 'Te asignamos {count} propuesta para ordenar. Tienes tiempo hasta el {date}.',
          other: 'Te asignamos {count} propuestas para ordenar. Tienes tiempo hasta el {date}.',
        }),
      },
      votingNoProposal: {
        title: 'Empezó la votación en «{event}»',
        body: 'No participas porque no subiste una propuesta.',
      },
      results: {
        title: 'Se publicaron los resultados de «{event}»',
        bodyPosition: 'Quedaste en el puesto {position} de {total}.',
        bodyNoPosition: 'Mira el ranking final.',
      },
      cancelled: {
        title: 'Se canceló «{event}»',
        body: 'El organizador canceló el evento.',
      },
      paused: {
        title: 'Se pausó «{event}»',
        body: 'El organizador pausó el evento por ahora.',
      },
      deadlineChanged: {
        title: 'Cambió el cierre de «{event}»',
        bodyParticipation: 'La inscripción ahora cierra el {date}.',
        bodyVoting: 'La votación ahora cierra el {date}.',
      },
      registered: {
        title: plural({
          one: '{count} persona se inscribió en «{event}»',
          other: '{count} personas se inscribieron en «{event}»',
        }),
      },
      registrationConfirmed: {
        title: 'Te inscribiste en «{event}»',
        body: 'Ya puedes subir tu propuesta.',
      },
      rankingSubmitted: {
        title: 'Enviaste tu ranking en «{event}»',
        titleReplaced: 'Actualizaste tu ranking en «{event}»',
        body: 'Lo puedes modificar hasta que cierre la votación.',
      },
      fileReminder: {
        title: 'Falta tu archivo en «{event}»',
        body: 'La inscripción cierra el {date}.',
      },
      voteReminder: {
        title: 'Falta tu ranking en «{event}»',
        body: 'La votación cierra el {date}.',
      },
    },
  },
  language: {
    es: 'Español',
    en: 'English',
  },
  stages: {
    creation: { name: 'Creación' },
    participation: { name: 'Participación' },
    voting: { name: 'Votación' },
    results: { name: 'Resultados' },
  },
  notFound: {
    title: 'No encontramos esta página',
    description: 'Puede que el enlace esté mal escrito o que el evento ya no esté disponible.',
    goToEvents: 'Ir a Eventos',
    backHome: 'Volver al inicio',
    documentTitle: 'Página no encontrada · Telescopio',
  },
  footer: {
    tagline: 'Telescopio · evaluación distribuida entre pares',
  },
  auth: {
    layout: {
      backHome: '← Volver al inicio',
      demoNote: 'Proyecto demo · los datos pueden reiniciarse',
    },
    fields: {
      email: 'Email',
      emailPlaceholder: 'nombre@correo.com',
      password: 'Contraseña',
      passwordPlaceholder: 'Tu contraseña',
      passwordRule: 'Al menos 8 caracteres.',
      newPasswordPlaceholder: 'Al menos 8 caracteres',
      showPassword: 'Mostrar',
      hidePassword: 'Ocultar',
      fullName: 'Nombre completo',
      fullNamePlaceholder: 'Tu nombre',
    },
    google: {
      continue: 'Continuar con Google',
      separator: 'o con tu email',
      error: 'No pudimos conectarte con Google. Inténtalo de nuevo.',
    },
    validation: {
      emailInvalid: 'Ingresa un email válido.',
      passwordRequired: 'Ingresa tu contraseña.',
      nameRequired: 'Ingresa tu nombre.',
      passwordMin: 'Usa al menos 8 caracteres.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      nameMin: 'Usa al menos 3 caracteres.',
      nameMax: 'Usa como máximo 100 caracteres.',
    },
    login: {
      brandTitle: 'Vuelve a donde dejaste tus eventos.',
      brandTitleNext: 'Inicia sesión para continuar.',
      benefitFollow: 'Sigue el estado de los eventos donde participas',
      benefitSubmit: 'Sube tu propuesta y vota cuando te toque',
      benefitResults: 'Consulta los rankings finales completos',
      title: 'Iniciar sesión',
      noAccount: '¿No tienes cuenta?',
      createOne: 'Crea una gratis',
      forgot: '¿La olvidaste?',
      submit: 'Iniciar sesión',
      submitting: 'Iniciando sesión…',
      error: 'No pudimos iniciar sesión. Inténtalo de nuevo.',
    },
    register: {
      brandTitle: 'Participa en eventos donde la comunidad decide.',
      benefitJoin: 'Inscríbete y sube tu propuesta',
      benefitEvaluate: 'Evalúa a otros participantes',
      benefitCreate: 'Crea tus propios eventos',
      title: 'Crear cuenta',
      haveAccount: '¿Ya tienes cuenta?',
      login: 'Inicia sesión',
      submit: 'Crear cuenta',
      submitting: 'Creando cuenta…',
      emailTaken: 'Ya hay una cuenta con este email. Inicia sesión o recupera tu contraseña.',
      error: 'No pudimos crear tu cuenta. Inténtalo de nuevo.',
    },
    forgot: {
      brandTitle: 'Recupera el acceso a tus eventos.',
      backToLogin: '← Volver a iniciar sesión',
      title: 'Recuperar contraseña',
      explanation: 'Te enviaremos un enlace para definir una contraseña nueva. Si te inscribiste en un evento con un enlace y nunca creaste una contraseña, usa esta opción para crearla.',
      submit: 'Enviar enlace',
      submitting: 'Enviando…',
      sentTitle: 'Revisa tu email',
      sentBody: 'Si hay una cuenta con {email}, te enviamos un enlace. Vence en 1 hora. Revisa también la carpeta de spam.',
      error: 'No pudimos enviar el enlace. Inténtalo de nuevo.',
    },
    reset: {
      brandTitle: 'Un paso más y vuelves a tus eventos.',
      title: 'Define tu nueva contraseña',
      newPassword: 'Nueva contraseña',
      repeatPassword: 'Repite la contraseña',
      submit: 'Guardar contraseña',
      submitting: 'Guardando…',
      error: 'No pudimos guardar la contraseña. Inténtalo de nuevo.',
      successTitle: 'Contraseña actualizada',
      successBody: 'Ya puedes iniciar sesión con tu nueva contraseña.',
      goToLogin: 'Iniciar sesión',
      invalidTitle: 'El enlace no es válido o venció',
      invalidBody: 'Los enlaces de recuperación vencen en 1 hora y sirven una sola vez. Pide uno nuevo.',
      requestNew: 'Pedir un enlace nuevo',
    },
    completeProfile: {
      brandTitle: 'Ya casi estás.',
      title: 'Elige tu nombre',
      explanation: 'Es el nombre que ven los organizadores y el que aparece en los resultados de los eventos.',
      name: 'Nombre',
      namePlaceholder: 'Al menos 3 caracteres',
      submit: 'Continuar',
      submitting: 'Guardando…',
      nameTaken: 'Ese nombre ya está en uso. Prueba con otro.',
      error: 'No pudimos guardar tu nombre. Inténtalo de nuevo.',
    },
  },
  home: {
    eyebrow: 'Evaluación entre pares · votación distribuida',
    title: 'Concursos donde la comunidad decide quién gana.',
    subtitle: 'Crea un evento, recibe propuestas y deja que los propios participantes se evalúen entre sí. Resultados justos, sin jurado central.',
    explore: 'Explorar eventos abiertos →',
    create: 'Crear un evento',
    featured: {
      label: 'Evento destacado',
      status: 'Inscripción abierta',
      closesIn: plural({ one: 'Cierra en {count} día', other: 'Cierra en {count} días' }),
      closesToday: 'Cierra hoy',
      capacity: '{count} de {max} lugares ocupados',
      participate: 'Participar',
    },
    how: {
      eyebrow: 'Cómo funciona',
      title: 'Cuatro etapas, siempre visibles',
      step: '{number} · {stage}',
      creation: 'El organizador define el evento y su cupo.',
      participation: 'Te inscribes y subes tu propuesta antes del cierre.',
      voting: 'Cada participante evalúa y ordena propuestas de otros.',
      results: 'Se publica el ranking final para todos.',
    },
    open: {
      title: 'Abiertos ahora',
      seeAll: 'Ver todos los eventos →',
      cta: 'Ver y participar',
      empty: 'Ahora no hay eventos con inscripción abierta.',
      emptyAction: 'Ver todos los eventos',
      error: 'No pudimos cargar los eventos abiertos.',
      loading: 'Cargando eventos…',
    },
    banner: {
      title: '¿Quieres evaluar propuestas con tu comunidad?',
      text: 'Configurar un evento toma menos de 5 minutos.',
      cta: 'Crear mi primer evento',
    },
  },
  events: {
    timeline: {
      now: 'Ahora',
      completed: 'Completada',
      pending: 'Pendiente',
      stepOf: 'Etapa {number} de 4',
    },
    pill: {
      participation: 'Inscripción abierta',
      voting: 'Votación',
      results: 'Finalizado',
      draft: 'Borrador · no visible',
      paused: 'Pausado',
      cancelled: 'Cancelado',
    },
    actions: {
      manage: 'Gestionar',
      participate: 'Participar',
      upload: 'Subir archivo',
      view: 'Ver evento',
      vote: 'Votar',
      results: 'Ver resultados',
      requiresAccount: 'Requiere cuenta',
      public: 'Público',
      accessibleName: '{action} {name}',
    },
    table: {
      event: 'Evento',
      stage: 'Etapa',
      participants: 'Participantes',
      created: 'Creado',
      close: 'Cierre',
      myStatus: 'Mi estado',
      action: 'Acción',
      capacity: '{count} / {max}',
      capacityText: '{count} de {max} lugares ocupados',
      registered: plural({ one: '{count} inscrito', other: '{count} inscritos' }),
    },
    myStatus: {
      missingFile: 'Falta tu archivo',
      proposalSent: 'Propuesta enviada',
      toVote: 'Te toca votar',
      rankingSent: 'Ranking enviado',
      notVoting: 'No participas en la votación',
      position: 'Puesto {position} de {total}',
    },
    pending: {
      title: 'Tus pendientes · {count}',
      uploadTitle: 'Falta subir tu archivo',
      uploadAction: 'Subir archivo',
      voteTitle: 'Te toca votar',
      voteAction: 'Votar',
      resultsTitle: 'Resultados publicados',
      resultsPosition: 'Quedaste en el puesto {position} de {total}',
      resultsAction: 'Ver ranking',
      closes: 'Cierra el {date}',
      seeAll: 'Ver todos en Mis eventos',
      error: 'No pudimos cargar tus pendientes.',
      loading: 'Cargando tus pendientes…',
    },
    list: {
      eyebrowGuest: 'Explorar · {count} eventos públicos',
      title: 'Eventos',
      subtitle: 'Encuentra dónde participar o sigue los eventos que ya te involucran.',
      subtitleGuest: 'Mira qué se está evaluando y consulta los resultados publicados. Para participar o crear tu propio evento necesitas una cuenta gratuita.',
      create: '+ Crear evento',
      createGuest: 'Crear un evento',
      filtersLabel: 'Filtrar por etapa',
      filterAll: 'Todos',
      filterParticipation: 'Inscripción abierta',
      filterVoting: 'En votación',
      filterResults: 'Finalizados',
      filterAccessible: plural({ one: '{label}, {count} evento', other: '{label}, {count} eventos' }),
      searchLabel: 'Buscar eventos',
      searchPlaceholder: 'Buscar por nombre u organizador',
      searchClear: 'Borrar búsqueda',
      resultsCount: plural({ one: '{count} evento', other: '{count} eventos' }),
      loading: 'Cargando eventos…',
      noMatches: 'No hay eventos que coincidan con tu búsqueda.',
      clearFilters: 'Limpiar filtros',
      noEvents: 'Todavía no hay eventos públicos.',
      error: 'No pudimos cargar los eventos.',
      paginationLabel: 'Paginación',
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: '{page} de {total}',
      howTitle: 'Cómo participar',
      howStep1: 'Elige un evento con inscripción abierta',
      howStep2: 'Crea tu cuenta e inscríbete',
      howStep3: 'Sube tu propuesta',
      howStep4: 'Vota a otros participantes',
      bannerTitle: '¿Quieres que tu comunidad evalúe propuestas?',
      bannerText: 'Crea una cuenta gratis y arma tu evento en menos de 5 minutos.',
      bannerCta: 'Crear cuenta gratis',
    },
  },
  myEvents: {
    title: 'Mis eventos',
    subtitle: 'Los eventos que organizas y en los que participas, en un solo lugar.',
    create: '+ Crear evento',
    organizingTitle: 'Organizo · {count}',
    organizingEmpty: 'Todavía no has organizado ningún evento.',
    organizingEmptyAction: 'Crear evento',
    participatingTitle: 'Participo · {count}',
    participatingEmpty: 'Todavía no te has inscrito en ningún evento.',
    participatingEmptyAction: 'Explorar eventos',
    error: 'No pudimos cargar tus eventos.',
    loading: 'Cargando tus eventos…',
  },
  eventForm: {
    nameLabel: 'Nombre del evento',
    namePlaceholder: 'Ej. Concurso de fotografía primavera 2026',
    nameHelp: 'Es lo primero que verán en la lista de eventos.',
    descriptionLabel: 'Descripción',
    descriptionHelp: 'Incluye qué deben enviar y cómo se evalúa.',
    organizerLabel: 'Organizador',
    optional: '(opcional)',
    organizerPlaceholder: 'Ej. Club de Fotografía',
    organizerHelp: 'Si lo dejas vacío se muestra tu nombre.',
    capacityLabel: 'Cupo de participantes',
    capacityLabelShort: 'Cupo',
    capacityRange: 'Entre 1 y 100',
    capacityMin: plural({ one: 'Mínimo {count}: ya hay {count} inscrito.', other: 'Mínimo {count}: ya hay {count} inscritos.' }),
    capacityDecrement: 'Restar uno al cupo',
    capacityIncrement: 'Sumar uno al cupo',
    validation: {
      nameMin: 'El nombre tiene que tener al menos 3 caracteres.',
      nameMax: 'El nombre puede tener hasta 200 caracteres.',
      descriptionMin: 'La descripción tiene que tener al menos 10 caracteres.',
      descriptionMax: 'La descripción puede tener hasta 2000 caracteres.',
      organizerMax: 'Puede tener hasta 200 caracteres.',
      capacityRange: 'El cupo tiene que estar entre 1 y 100.',
      capacityBelowRegistered: plural({ one: 'El cupo no puede ser menor a {count} inscrito.', other: 'El cupo no puede ser menor a los {count} inscritos.' }),
    },
  },
  createEvent: {
    breadcrumbLabel: 'Ruta de navegación',
    breadcrumbEvents: 'Eventos',
    title: 'Crear evento',
    stepsLabel: 'Pasos del asistente',
    steps: {
      identification: 'Identificación',
      capacity: 'Fechas y cupo',
      review: 'Revisar y crear',
    },
    stepCurrent: 'En curso',
    stepCompleted: '{name}, completado',
    stepOf: 'Paso {number} de 3',
    stepAnnouncement: 'Paso {number} de 3, {name}',
    questions: {
      identification: '¿De qué se trata tu evento?',
      capacity: '¿Cuántas personas pueden participar?',
      review: 'Revisa y crea tu evento',
    },
    capacityHelp: 'Cuando se completa el cupo nadie más puede inscribirse. Puedes cambiarlo mientras la inscripción esté abierta.',
    review: {
      name: 'Nombre',
      description: 'Descripción',
      organizer: 'Organizador',
      capacity: 'Cupo',
      capacityValue: plural({ one: '{count} participante', other: '{count} participantes' }),
      organizerFallback: '{name} (tu nombre)',
      edit: 'Editar',
      editField: 'Editar {field}',
    },
    visibilityNotice: 'El evento se crea en etapa Creación: nadie más puede verlo hasta que abras la inscripción. La fecha de cierre la defines en ese momento.',
    preview: {
      title: 'Vista previa en la lista',
      namePlaceholder: 'Nombre del evento',
      descriptionPlaceholder: 'La descripción aparecerá aquí.',
      by: 'por {organizer}',
    },
    tipTitle: 'Consejo',
    tip: 'Los eventos con criterios de evaluación claros reciben votos más consistentes.',
    errors: {
      generic: 'No pudimos crear el evento. Inténtalo de nuevo.',
    },
    cancel: 'Cancelar',
    back: '← Atrás',
    nextCapacity: 'Siguiente: Fechas y cupo →',
    nextReview: 'Siguiente: Revisar →',
    submit: 'Crear evento',
    submitting: 'Creando evento…',
    saveDraft: 'Guardar borrador',
    draftSaved: 'Borrador guardado.',
    draftSaving: 'Guardando…',
    draftAutosaved: 'Borrador guardado hace {age}',
    draftAgeSeconds: '{count} s',
    draftAgeMinutes: '{count} min',
    draftAgeHours: '{count} h',
    discard: {
      title: '¿Descartar el evento?',
      text: 'Se perderá lo que cargaste.',
      keep: 'Seguir editando',
      confirm: 'Descartar',
      close: 'Cerrar',
    },
  },
  editEvent: {
    title: 'Editar datos del evento',
    close: 'Cerrar',
    cancel: 'Cancelar',
    save: 'Guardar cambios',
    saving: 'Guardando…',
    errors: {
      generic: 'No pudimos guardar los cambios. Inténtalo de nuevo.',
      stageLocked: 'El evento ya pasó a votación y sus datos no se pueden editar.',
    },
    discard: {
      title: '¿Descartar los cambios?',
      keep: 'Seguir editando',
      confirm: 'Descartar',
    },
  },
  manageEvent: {
    created: 'Evento creado. Cuando esté listo, abre la inscripción.',
    updated: 'Datos actualizados.',
  },
  manage: {
    back: '← Mis eventos',
    aside: 'Panel lateral',
    role: 'Organizas este evento',
    meta: '{organizer} · creado el {date}',
    editData: 'Editar datos',
    copyInvite: 'Copiar enlace de invitación',
    copied: '✓ Copiado',
    share: 'Compartir',
    loading: 'Cargando gestión…',
    loadError: 'No pudimos cargar el evento.',
    goToEvents: 'Ir a Eventos',
    forbidden: {
      title: 'No tienes permiso para gestionar este evento',
      text: 'Solo quien creó el evento puede gestionarlo.',
    },
    pill: {
      draft: 'Borrador · no visible',
      open: 'Inscripción abierta',
      openCloses: plural({ one: 'Inscripción abierta · cierra en {count} día', other: 'Inscripción abierta · cierra en {count} días' }),
      openClosesToday: 'Inscripción abierta · cierra hoy',
      voting: 'Votación en curso',
      votingCloses: plural({ one: 'Votación en curso · cierra en {count} día', other: 'Votación en curso · cierra en {count} días' }),
      votingClosesToday: 'Votación en curso · cierra hoy',
      results: 'Finalizado · resultados publicados',
      paused: 'Pausado',
      cancelled: 'Cancelado',
    },
    timeline: {
      creationNow: 'Configuras el evento',
      noDeadline: 'Sin fecha de cierre',
      closes: 'Cierra el {date}',
      files: plural({ one: '{count} archivo recibido', other: '{count} archivos recibidos' }),
      published: 'Publicados',
      edit: 'editar',
    },
    metrics: {
      registered: 'Inscriptos',
      registeredA11y: 'Inscriptos: {count} de {max}',
      files: 'Archivos recibidos',
      filesA11y: 'Archivos recibidos: {count} de {total}',
      rankings: 'Rankings enviados',
      rankingsValue: '{sent} de {total}',
      rankingsA11y: 'Rankings enviados: {sent} de {total}',
      deadline: 'Cierre',
      days: plural({ one: '{count} día', other: '{count} días' }),
      closesToday: 'Cierra hoy',
      noDeadline: 'Sin definir',
    },
    participants: {
      title: 'Participantes',
      titleWithCount: 'Participantes · {count} / {max}',
      caption: 'Participantes del evento',
      name: 'Nombre',
      email: 'Email',
      file: 'Archivo',
      registeredAt: 'Inscripción',
      vote: 'Voto',
      fileMissing: 'Falta archivo',
      download: 'Descargar {name}',
      voteSent: '✓ Enviado',
      votePending: 'Pendiente',
      voteNotParticipating: 'No participa',
      error: 'No pudimos cargar los participantes.',
      statsError: 'No pudimos cargar las estadísticas de votación.',
      downloadError: 'No pudimos descargar «{name}». Intenta de nuevo.',
    },
    empty: {
      title: 'Todavía no hay inscriptos',
      creation: 'Cuando abras la inscripción podrás compartir el enlace.',
      participation: 'Comparte el enlace de invitación para sumar participantes.',
    },
    reminder: {
      file: plural({ one: 'Recordar a quienes no subieron archivo ({count})', other: 'Recordar a quienes no subieron archivo ({count})' }),
      vote: plural({ one: 'Enviar recordatorio a {count} pendiente', other: 'Enviar recordatorio a {count} pendientes' }),
      sent: 'Recordatorio enviado',
    },
    nextStep: {
      eyebrow: 'Próximo paso',
      creation: {
        title: 'Abre la inscripción',
        text: 'Mientras esté en creación, nadie puede ver ni sumarse al evento. Revisa que esté todo listo:',
        action: 'Abrir inscripción →',
      },
      checklist: {
        details: 'Nombre y descripción',
        capacity: 'Cupo: {count} participantes',
        deadline: 'Fecha de cierre de inscripción (la defines al abrir)',
      },
      participation: {
        title: 'Pasar a votación',
        text: 'Se cierra la inscripción y cada participante con propuesta recibe propuestas de otros para evaluar.',
        action: 'Configurar y abrir votación →',
      },
      voting: {
        title: 'Publicar resultados',
        text: 'Recomendado cuando todos hayan votado o al llegar el cierre ({date}).',
        textNoDate: 'Recomendado cuando todos hayan votado o al llegar el cierre.',
        action: 'Cerrar votación y publicar',
      },
    },
    consequence: {
      missingFiles: plural({ one: '{count} participante todavía no subió su archivo y no va a evaluar ni ser evaluado.', other: '{count} participantes todavía no subieron su archivo y no van a evaluar ni ser evaluados.' }),
      minimum: 'Se necesitan al menos 3 participantes con propuesta para abrir la votación. Hoy hay {count}.',
      missingRankings: 'Faltan {missing} de {total} rankings.',
    },
    config: {
      title: 'Configuración aplicada',
      text: plural({ one: '{count} propuesta por evaluador · mínimo {min} evaluaciones por archivo · ajustes de calidad {quality}', other: '{count} propuestas por evaluador · mínimo {min} evaluaciones por archivo · ajustes de calidad {quality}' }),
      recommended: 'recomendados',
      custom: 'personalizados',
      error: 'No pudimos cargar la configuración aplicada.',
    },
    summary: {
      title: 'Resumen',
      participants: 'Participantes',
      participantsValue: '0 / {max}',
      files: 'Archivos',
      deadline: 'Cierre inscripción',
      notSet: 'Sin definir',
    },
    after: {
      title: 'Después',
      text: 'Los participantes se inscriben y suben su archivo hasta la fecha de cierre que definas.',
    },
    countdown: {
      registration: {
        title: 'LA INSCRIPCIÓN CIERRA EN',
        expired: 'LA INSCRIPCIÓN YA CERRÓ',
        days: 'DÍAS',
        hours: 'HORAS',
        minutes: 'MIN',
        seconds: 'SEG',
        footer: '{date} · 23:59 (ART)',
      },
      voting: {
        title: 'LA VOTACIÓN CIERRA EN',
        expired: 'LA VOTACIÓN YA CERRÓ',
        days: 'DÍAS',
        hours: 'HORAS',
        minutes: 'MIN',
        seconds: 'SEG',
        footer: '{date} · 23:59 (ART)',
      },
    },
    pause: {
      action: 'Pausar evento',
      resume: 'Reanudar evento',
      confirmTitle: '¿Pausar el evento?',
      confirmText: 'Mientras esté pausado nadie puede inscribirse, subir propuestas ni votar.',
      cancel: 'Cancelar',
      error: 'No pudimos cambiar el estado del evento. Intenta de nuevo.',
    },
    pausedNotice: 'El evento está pausado. Los participantes no pueden inscribirse, subir propuestas ni votar hasta que lo reanudes.',
    success: {
      registrationOpened: 'Se abrió la inscripción. Comparte el enlace para sumar participantes.',
      votingOpened: 'Se abrió la votación. Se asignaron las propuestas.',
      resultsPublished: 'Resultados publicados.',
      reminderSent: plural({ one: 'Recordatorio enviado a {count} participante.', other: 'Recordatorio enviado a {count} participantes.' }),
      deadlineUpdated: 'Cierre actualizado.',
    },
    dialog: {
      close: 'Cerrar',
      cancel: 'Cancelar',
      presets: {
        '3': '3 días',
        '7': '1 semana',
        '14': '2 semanas',
      },
      postponePresets: {
        '3': '+3 días',
        '7': '+1 semana',
        '14': '+2 semanas',
      },
      change: 'Cambiar',
      dateNotAfterToday: 'Elige una fecha posterior a hoy.',
    },
    openRegistration: {
      eyebrow: 'Creación → Participación',
      title: 'Abrir inscripción',
      text: 'El evento pasa a ser público. Las personas van a poder inscribirse y subir su archivo.',
      dateLabel: '¿Hasta cuándo se pueden inscribir?',
      help: 'Se muestra a los participantes. Puedes posponerla después.',
      error: 'No pudimos abrir la inscripción. Intenta de nuevo.',
      confirm: 'Abrir inscripción',
      loading: 'Abriendo…',
    },
    openVoting: {
      eyebrow: 'Participación → Votación',
      title: 'Abrir votación',
      text: 'Se cierra la inscripción y el sistema reparte las propuestas entre los participantes que subieron la suya. Nadie evalúa su propio archivo.',
      proposals: 'Propuestas',
      reviewers: 'Evaluadores',
      perFile: 'Evaluaciones por archivo',
      leftOut: plural({ one: '{count} inscripto no subió su propuesta: no va a evaluar ni ser evaluado.', other: '{count} inscriptos no subieron su propuesta: no van a evaluar ni ser evaluados.' }),
      minimum: 'Se necesitan al menos 3 participantes con propuesta para abrir la votación. Hoy hay {count}.',
      dateLabel: 'Cierre de la votación',
      perReviewer: 'Propuestas por evaluador',
      perReviewerHelp: 'Recomendado: {recommended} · máximo {max}',
      decrement: 'Una propuesta menos por evaluador',
      increment: 'Una propuesta más por evaluador',
      advanced: 'Ajustes avanzados de calidad',
      advancedHint: 'Valores recomendados · funcionan bien para la mayoría de los eventos',
      advancedShow: 'Mostrar',
      advancedHide: 'Ocultar',
      minEvaluations: 'Evaluaciones mínimas por archivo',
      adjustment: 'Peso del ajuste por calidad',
      adjustmentUnit: 'posiciones',
      adjustmentRange: 'Elige un valor entre 1 y 10.',
      goodThreshold: 'Umbral de evaluador confiable',
      goodThresholdHelp: 'Por encima, su voto pesa más.',
      badThreshold: 'Umbral de evaluador poco confiable',
      badThresholdHelp: 'Por debajo, su voto pesa menos.',
      thresholdError: 'El umbral confiable tiene que superar al poco confiable por al menos 0,1.',
      stepperDecrement: 'Bajar {label}',
      stepperIncrement: 'Subir {label}',
      irreversible: 'No se puede volver a Participación.',
      error: 'No pudimos abrir la votación. El evento sigue en Participación; intenta de nuevo.',
      previewLoading: 'Calculando el reparto…',
      previewError: 'No pudimos calcular el reparto.',
      confirm: 'Abrir votación y asignar',
      loading: 'Abriendo votación…',
    },
    publish: {
      eyebrow: 'Votación → Resultados',
      title: '¿Cerrar votación y publicar?',
      text: 'Se calcula el ranking final y queda visible para todos. Nadie podrá votar después.',
      missingTitle: 'Faltan {missing} de {total} rankings',
      missingText: 'Con pocos votos el resultado es menos confiable. Quien no envió su ranking queda con calidad 0 y su propuesta baja posiciones.',
      error: 'No pudimos publicar los resultados. Intenta de nuevo.',
      wait: 'Seguir esperando',
      confirmAnyway: 'Publicar igual',
      confirm: 'Publicar resultados',
      loading: 'Publicando…',
    },
    reminderDialog: {
      fileTitle: 'Recordar que falta el archivo',
      voteTitle: 'Recordar que falta el ranking',
      text: plural({ one: '{count} participante va a recibir un email y una notificación en la app con el cierre de la etapa.', other: '{count} participantes van a recibir un email y una notificación en la app con el cierre de la etapa.' }),
      more: plural({ one: 'y {count} más', other: 'y {count} más' }),
      none: 'Ya no hay pendientes.',
      error: 'No pudimos enviar el recordatorio. Intenta de nuevo.',
      paused: 'El evento está pausado; reanúdalo para enviar recordatorios.',
      confirm: 'Enviar recordatorio',
      loading: 'Enviando…',
    },
    deadline: {
      eyebrowParticipation: 'Participación',
      eyebrowVoting: 'Votación',
      title: 'Posponer el cierre',
      current: 'Cierre actual: {date}',
      label: 'Nuevo cierre',
      help: 'El cierre solo se puede posponer. Los participantes reciben un email y una notificación con la nueva fecha.',
      notPostponed: 'El cierre solo se puede posponer. Elige una fecha posterior al {date}.',
      error: 'No pudimos cambiar el cierre. Intenta de nuevo.',
      confirm: 'Posponer cierre',
      loading: 'Guardando…',
    },
  },
  ranking: {
    proposal: 'Propuesta {number}',
    meta: '{type} · {size}',
    viewFile: 'Ver archivo',
    viewFileAccessible: 'Ver archivo de {proposal}',
    best: 'La mejor',
    middle: 'Intermedia',
    worst: 'La que menos',
    moveUp: 'Subir {proposal}',
    moveDown: 'Bajar {proposal}',
    moved: '{proposal} pasó a la posición {position}',
    listLabel: 'Tu ranking de propuestas',
    readonlyTitle: 'Tu ranking',
  },
  eventDetail: {
    back: '← Eventos',
    share: 'Compartir',
    meta: 'Organiza {organizer} · {count} de {max} participantes',
    metaFinished: 'Finalizó el {date}',
    loading: 'Cargando evento…',
    loadError: 'No pudimos cargar el evento.',
    goToEvents: 'Ir a Eventos',
    pill: {
      open: 'Inscripción abierta',
      openCloses: plural({ one: 'Inscripción abierta · cierra en {count} día', other: 'Inscripción abierta · cierra en {count} días' }),
      openClosesToday: 'Inscripción abierta · cierra hoy',
      missingFile: 'Inscrito · falta tu archivo',
      proposalSent: 'Propuesta enviada',
      vote: 'Te toca votar',
      voteCloses: plural({ one: 'Te toca votar · cierra en {count} día', other: 'Te toca votar · cierra en {count} días' }),
      voteClosesToday: 'Te toca votar · cierra hoy',
      rankingSent: 'Ranking enviado',
      votingInProgress: 'Votación en curso',
      results: 'Finalizado · resultados publicados',
      paused: 'Evento pausado',
      cancelled: 'Cancelado',
    },
    timeline: {
      creation: 'Evento configurado',
      participation: 'Inscríbete y sube tu archivo',
      voting: 'Evalúas a otros participantes',
      results: 'Ranking final',
      closes: 'Cierra el {date}',
    },
    nextStep: {
      eyebrow: 'Tu próximo paso',
      default: {
        title: 'Inscríbete para participar',
        text: 'Después de inscribirte podrás subir tu propuesta. Puedes reemplazarla hasta el cierre.',
      },
      upload: {
        title: 'Sube tu propuesta',
        text: 'Puedes reemplazarla las veces que quieras hasta el {date}.',
        textNoDate: 'Puedes reemplazarla las veces que quieras hasta el cierre.',
      },
      submitted: {
        title: 'Tu propuesta está enviada',
        text: 'Puedes reemplazarla hasta el {date}.',
        textNoDate: 'Puedes reemplazarla hasta el cierre.',
      },
      vote: {
        title: plural({ one: 'Ordena la {count} propuesta', other: 'Ordena las {count} propuestas' }),
        text: 'Arriba la que te parece mejor. Abre cada archivo antes de decidir.',
      },
      rankingSent: {
        title: 'Tu ranking está enviado',
        text: 'Puedes modificarlo y reenviarlo hasta el cierre de la votación.',
      },
      paused: {
        title: 'El evento está pausado',
        text: 'Por ahora no se puede inscribir ni subir propuestas. El organizador reanudará el evento.',
      },
      full: {
        title: 'El cupo está completo',
        text: 'No quedan lugares en este evento.',
      },
      noProposalInVoting: {
        title: 'No participas en esta votación',
        text: 'No subiste una propuesta durante la inscripción, así que en este evento no evalúas ni recibes evaluaciones.',
      },
      votingNotRegistered: {
        title: 'La votación está en curso',
        text: 'Los participantes están evaluando las propuestas. Los resultados se publican al cerrar la votación.',
      },
      results: {
        title: 'Así votó la comunidad',
        text: '{participants} · {evaluations}',
      },
      cancelled: {
        title: 'Este evento fue cancelado',
        text: 'Ya no se puede participar en este evento.',
      },
    },
    requirements: {
      label: 'Requisitos',
      formats: 'Imagen o documento',
      size: 'Máx. 10 MB',
      closes: 'Cierre: {date}',
    },
    register: 'Inscribirme al evento',
    registering: 'Inscribiendo…',
    upload: {
      prompt: 'Arrastra tu archivo aquí o',
      promptAction: 'elígelo desde tu equipo',
      formats: 'JPG, PNG, GIF, WebP, PDF, TXT, DOC, DOCX · hasta 10 MB',
      ready: 'listo para enviar',
      change: 'Cambiar',
      changeAccessible: 'Cambiar archivo {name}',
      submittedOn: 'Enviada el {date}',
      replace: 'Reemplazar archivo',
      tooLarge: 'El archivo supera los 10 MB.',
      invalidType: 'Ese formato no está permitido. Usa JPG, PNG, GIF, WebP, PDF, TXT, DOC o DOCX.',
      multiple: 'Elige un solo archivo.',
    },
    comment: {
      label: 'Comentario',
      optional: '(opcional)',
      help: 'Lo verán los evaluadores junto a tu archivo.',
    },
    submit: 'Enviar propuesta',
    submitReplace: 'Enviar nueva versión',
    submitting: 'Enviando propuesta…',
    submitHelpEmpty: 'Elige un archivo para continuar',
    submitHelpReady: 'Podrás reemplazarlo hasta el cierre',
    received: 'Recibimos tu propuesta.',
    errors: {
      register: 'No pudimos inscribirte. Intenta de nuevo.',
      upload: 'No pudimos enviar tu propuesta. Intenta de nuevo.',
      replace: 'No pudimos reemplazar tu propuesta. Intenta de nuevo.',
      assignment: 'No pudimos cargar tus propuestas asignadas.',
      openFile: 'No pudimos abrir el archivo. Intenta de nuevo.',
      submitRanking: 'No pudimos enviar tu ranking. Intenta de nuevo.',
      saveDraft: 'No pudimos guardar el borrador. Tus cambios siguen en pantalla.',
      votingClosed: 'La votación ya cerró. No se puede modificar el ranking.',
    },
    ranking: {
      submit: 'Enviar mi ranking',
      resubmit: 'Reenviar mi ranking',
      submitting: 'Enviando ranking…',
      help: 'Puedes modificarlo hasta el cierre de la votación.',
      draftSaved: 'Borrador guardado',
    },
    rankingReceived: 'Recibimos tu ranking.',
    progress: {
      title: 'Tu progreso',
      done: 'Completado',
      registration: 'Inscripción',
      confirmed: 'Confirmada',
      upload: 'Subir propuesta',
      pending: 'Pendiente',
      pendingCloses: plural({ one: 'Pendiente · cierra en {count} día', other: 'Pendiente · cierra en {count} días' }),
      sent: 'Enviada',
      vote: 'Votar',
      voteLater: 'Te avisamos cuando empiece',
      voteSent: 'Enviado',
      results: 'Ver resultados',
    },
    howVoteCounts: {
      title: '¿Cómo cuenta tu voto?',
      text: 'Tu orden se compara con el de los demás evaluadores. Si evalúas con coherencia, tu propia propuesta sube posiciones en el ranking final; si no, baja.',
    },
    about: 'Sobre el evento',
    details: {
      title: 'Detalles',
      organizer: 'Organiza',
      closes: 'Cierre de {stage}',
      participants: 'Participantes',
      participantsValue: '{count} / {max}',
      view: 'ver',
      viewAccessible: 'Ver participantes',
      evaluations: 'Evaluaciones',
      finished: 'Finalizó',
    },
    after: {
      title: 'Después',
      participation: 'Al cerrar la inscripción, el organizador abre la votación y te asigna propuestas para evaluar.',
      voting: 'Al cerrar la votación se publica el ranking final para todos.',
    },
    banner: {
      title: '¿Te gustó?',
      text: plural({ one: 'Hay {count} evento con inscripción abierta ahora.', other: 'Hay {count} eventos con inscripción abierta ahora.' }),
      guest: 'Crea tu cuenta para participar en el próximo.',
      cta: 'Ver eventos',
      createAccount: 'Crear cuenta',
    },
  },
  share: {
    eyebrow: 'Compartir',
    close: 'Cerrar',
    audience: {
      participation: 'Quien abra el enlace verá el evento y podrá inscribirse.',
      voting: 'Quien abra el enlace verá el evento.',
      results: 'Quien abra el enlace verá los resultados, aunque no tenga cuenta.',
    },
    linkLabel: 'Enlace del evento',
    copy: 'Copiar',
    copied: '✓ Copiado',
    copyFailed: 'No pudimos copiar el enlace. Selecciónalo y cópialo a mano.',
    via: 'o enviarlo por',
    networks: {
      whatsapp: 'WhatsApp',
      x: 'X',
      linkedin: 'LinkedIn',
      facebook: 'Facebook',
      email: 'Email',
    },
    networkAccessible: 'Compartir por {network}',
    more: 'Más opciones',
  },
  participants: {
    title: 'Participantes · {count} / {max}',
    close: 'Cerrar',
    name: 'Nombre',
    registeredAt: 'Inscripción',
    empty: 'Todavía no hay inscritos.',
    error: 'No pudimos cargar los participantes.',
    loading: 'Cargando participantes…',
  },
  results: {
    podium: 'Podio',
    place: 'Puesto {position}',
    position: 'Posición',
    participant: 'Participante',
    proposal: 'Propuesta',
    score: 'Puntaje',
    ranking: 'Ranking completo',
    you: 'Tú',
    evaluations: plural({ one: '{count} evaluación', other: '{count} evaluaciones' }),
    note: 'El puntaje combina los rankings de todos los participantes, en una escala de 0 a 10. La propuesta de quien evaluó con coherencia sube posiciones; la de quien no, baja.',
    loading: 'Cargando resultados…',
    error: 'No pudimos cargar los resultados.',
  },
  errors: {
    ALREADY_CANCELLED: 'Este evento ya fue cancelado.',
    ALREADY_REGISTERED: 'Ya estás inscrito en este evento.',
    ASSIGNMENTS_EXIST: 'Las asignaciones de este evento ya fueron generadas.',
    ASSIGNMENT_NOT_FOUND: 'No encontramos esta asignación.',
    ATTACHMENTS_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    ATTACHMENT_NOT_FOUND: 'No encontramos esta propuesta.',
    BAD_REQUEST: 'No pudimos procesar la solicitud. Revisa los datos e inténtalo de nuevo.',
    CANCEL_ERROR: 'No pudimos cancelar el evento. Inténtalo de nuevo.',
    CANNOT_ADVANCE_DEADLINE: 'Solo puedes posponer la fecha estimada de cierre, no adelantarla.',
    CONFIG_EXISTS: 'La configuración de votación de este evento ya existe.',
    CONFIG_INVALID: 'La configuración de votación no es válida. Revísala e inténtalo de nuevo.',
    CONFIG_LOOKUP_ERROR: 'No pudimos consultar la configuración de votación. Inténtalo de nuevo.',
    CONFIG_NOT_FOUND: 'Este evento todavía no tiene configuración de votación.',
    CREATION_ERROR: 'No pudimos crear el evento. Inténtalo de nuevo.',
    CREATOR_CANNOT_DELETE: 'El organizador no puede quitarse de su propio evento.',
    CREATOR_CANNOT_REGISTER: 'El organizador no puede inscribirse en su propio evento.',
    CREATOR_CANNOT_UPLOAD: 'El organizador no puede subir una propuesta a su propio evento.',
    DB_CREATE_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    DB_DELETE_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    DB_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    DB_SAVE_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    DB_UPDATE_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    DESCRIPTION_TOO_LONG: 'La descripción es demasiado larga. Acórtala e inténtalo de nuevo.',
    DRAFT_GET_ERROR: 'No pudimos recuperar tu borrador. Inténtalo de nuevo.',
    DRAFT_NOT_FOUND: 'No encontramos un borrador guardado.',
    DRAFT_SAVE_ERROR: 'No pudimos guardar tu borrador. Inténtalo de nuevo.',
    DUPLICATE_ATTACHMENT: 'Ya subiste una propuesta a este evento.',
    DUPLICATE_EVENT_NAME: 'Ya existe un evento con este nombre. Elige otro.',
    DURATION_TOO_LONG: 'La duración del evento es demasiado larga. Acórtala e inténtalo de nuevo.',
    DURATION_TOO_SHORT: 'La duración del evento es demasiado corta. Amplíala e inténtalo de nuevo.',
    EMAIL_ALREADY_EXISTS: 'Ya existe una cuenta con este correo electrónico.',
    EVENT_CANCELLED: 'Este evento fue cancelado.',
    EVENT_LOOKUP_ERROR: 'No pudimos consultar el evento. Inténtalo de nuevo.',
    EVENT_NOT_FOUND: 'No encontramos este evento.',
    EVENT_PAUSED: 'Este evento está en pausa. Vuelve a intentarlo cuando se reanude.',
    EVENT_PAUSED_OR_CANCELLED: 'Este evento está en pausa o fue cancelado.',
    EXPIRED_RESET_TOKEN: 'El enlace para restablecer la contraseña venció. Solicita uno nuevo.',
    FILE_NOT_FOUND: 'No encontramos el archivo.',
    FILE_SAVE_ERROR: 'No pudimos guardar el archivo. Inténtalo de nuevo.',
    FILE_TOO_LARGE: 'El archivo es demasiado grande. Sube uno más liviano.',
    FORBIDDEN: 'No tienes permiso para hacer esto.',
    GENERATION_FAILED: 'No pudimos generar las asignaciones. Inténtalo de nuevo.',
    GOOGLE_API_ERROR: 'No pudimos conectar con Google. Inténtalo de nuevo en unos minutos.',
    INSUFFICIENT_ATTACHMENTS: 'Se necesitan al menos 3 propuestas para abrir la votación.',
    INSUFFICIENT_PARTICIPANTS: 'Faltan participantes para continuar.',
    INTERNAL_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    INVALID_ATTACHMENT_ID: 'El identificador de la propuesta no es válido.',
    INVALID_CREDENTIALS: 'El correo o la contraseña no son correctos.',
    INVALID_DATE_FORMAT: 'El formato de la fecha no es válido.',
    INVALID_DATE_RANGE: 'La fecha de fin debe ser posterior a la de inicio.',
    INVALID_END_DATE: 'La fecha de fin no es válida.',
    INVALID_ESTIMATED_DATE: 'La fecha estimada de cierre no es válida. Elige una fecha de hoy en adelante.',
    INVALID_EVENT_ID: 'El identificador del evento no es válido.',
    INVALID_EVENT_STAGE: 'Esta acción no está disponible en la etapa actual del evento.',
    INVALID_FILENAME: 'El nombre del archivo no es válido.',
    INVALID_FILE_TYPE: 'El tipo de archivo no está permitido.',
    INVALID_GOOGLE_TOKEN: 'No pudimos validar tu cuenta de Google. Inténtalo de nuevo.',
    INVALID_MAX_PARTICIPANTS: 'El máximo de participantes no es válido.',
    INVALID_PARTICIPANT_ID: 'El identificador del participante no es válido.',
    INVALID_PASSWORD: 'La contraseña no cumple los requisitos. Elige una más segura.',
    INVALID_PAYLOAD: 'Los datos enviados no son válidos. Revísalos e inténtalo de nuevo.',
    INVALID_REGISTRATION_STAGE: 'Este evento ya no admite inscripciones.',
    INVALID_RESET_TOKEN: 'El enlace para restablecer la contraseña no es válido. Solicita uno nuevo.',
    INVALID_STAGE: 'La etapa indicada no es válida.',
    INVALID_STAGE_FILTER: 'El filtro de etapa no es válido.',
    INVALID_STAGE_FOR_EDIT: 'No puedes editar esto en la etapa actual del evento.',
    INVALID_START_DATE: 'La fecha de inicio no es válida.',
    INVALID_THRESHOLDS: 'Los umbrales de la votación no son válidos.',
    INVALID_TOKEN: 'Tu sesión no es válida. Inicia sesión de nuevo.',
    INVALID_TRANSITION: 'No puedes pasar a esa etapa desde la actual.',
    INVALID_UPDATE_STAGE: 'No puedes modificar el evento en su etapa actual.',
    MATH_CONSTRAINT_VIOLATION: 'Los parámetros de votación no son compatibles entre sí. Ajústalos e inténtalo de nuevo.',
    MAX_PARTICIPANTS_BELOW_REGISTERED: 'El máximo no puede ser menor que la cantidad de inscritos.',
    MAX_PARTICIPANTS_LIMIT_EXCEEDED: 'El máximo de participantes supera el límite permitido.',
    MAX_PARTICIPANTS_REACHED: 'El cupo está completo. No quedan lugares en este evento.',
    MISSING_ESTIMATED_DATE: 'Indica la fecha estimada de cierre de la etapa.',
    MISSING_EVENT_ID: 'Falta el identificador del evento.',
    MISSING_PARAMETERS: 'Faltan datos para completar la acción.',
    MISSING_VOTING_CONFIG: 'Configura la votación antes de continuar.',
    M_EXCEEDS_EVALUABLE: 'La cantidad de propuestas a evaluar supera las que hay disponibles. Reduce ese número.',
    NOTIFICATION_NOT_FOUND: 'No encontramos esta notificación.',
    NOT_FOUND: 'No encontramos lo que buscabas.',
    NOT_REGISTERED: 'Primero debes inscribirte en el evento.',
    NO_ASSIGNMENT: 'Todavía no tienes propuestas asignadas para evaluar.',
    NO_ATTACHMENTS: 'Todavía no hay propuestas en este evento.',
    NO_AUTH_TOKEN: 'Inicia sesión para continuar.',
    NO_FILE: 'Selecciona un archivo para subir.',
    NO_PENDING_RECIPIENTS: 'No hay participantes pendientes a quienes enviar el recordatorio.',
    OAUTH_ACCOUNT_NO_PASSWORD: 'Esta cuenta usa Google para iniciar sesión. Ingresa con Google.',
    PARTICIPANTS_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    PARTICIPANT_CHECK_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    PARTICIPANT_NOT_FOUND: 'No encontramos a este participante.',
    PAST_START_DATE: 'La fecha de inicio no puede estar en el pasado.',
    REGISTRATION_ERROR: 'No pudimos completar el registro. Inténtalo de nuevo.',
    RESULTS_NOT_CALCULATED: 'Los resultados todavía no están disponibles.',
    RETRIEVAL_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    TOKEN_GENERATION_ERROR: 'No pudimos completar la acción en el servidor. Inténtalo de nuevo en unos minutos.',
    UNAUTHORIZED: 'Inicia sesión para continuar.',
    UNAUTHORIZED_ACCESS: 'No tienes acceso a este recurso.',
    UPDATE_ERROR: 'No pudimos guardar los cambios. Inténtalo de nuevo.',
    USERNAME_ALREADY_EXISTS: 'Ese nombre de usuario ya está en uso. Elige otro.',
    USER_CREATE_ERROR: 'No pudimos crear tu cuenta. Inténtalo de nuevo.',
    USER_NOT_FOUND: 'No encontramos esta cuenta.',
    VALIDATION_FAILED: 'Algunos datos no son válidos. Revísalos e inténtalo de nuevo.',
    VOTING_SETUP_ERROR: 'No pudimos preparar la votación. Inténtalo de nuevo.',
    generic: 'Algo salió mal. Inténtalo de nuevo.',
    network: 'No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.',
  },
};
